// definir un objeto mixin
var MpPaginator = {
    created: function () {},

    data: function() {
        return {
            page: 1,
            initialPage: 1,
            pageList: [],
            hasPagination: true,
        };
    },

    methods: {

        setInitialPage: function(pageNumber) {
            this.page = pageNumber;
            this.initialPage = pageNumber;

            // This call never trigger a loadItems call because
            // this.page always be the same as hash page
            this.showPage(pageNumber);
        },

        setPage: function(pageNumber) {
            // console.log('🛜 setPage - setting Page to '+pageNumber);
            this.page = pageNumber;
            this.initialPage = pageNumber;
            window.location.hash = '';
        },

        getPageFromHash: function() {
            var pageNumber = parseInt(window.location.hash.replace('#page', ''));
            return (pageNumber) ? parseInt(pageNumber) : this.initialPage;
        },

        getPageLinkStyle: function(linkPage) {
            // console.log(`🛜 Page ${linkPage} is current: ${this.page}`);
            return (parseInt(linkPage) === this.page) ? 'paginator__item-link--selected' : '';
        },

        onHashChange: function(ev) {
            var pageNumber = this.getPageFromHash();

            // console.log(`🛜 onHashChange - CurrentPage ${this.page} vs HashPage ${pageNumber}`);
            if (this.page === pageNumber) {
                return;
            }

            // console.log('🛜 onHashChange - setting current page to '+pageNumber);
            this.page = pageNumber;
            window.scroll({ top: 0, left: 0, behavior: 'smooth' });
            this.loadItems(true);
        },

        showPage: function(page) {
            // console.log('🛜 showPage: '+page);
            window.location.hash = 'page' + page;
        },

        addDomPage: function(pageItem) {
            this.pageList.push({
                link: pageItem.querySelector('.js-page-link').getAttribute('href'),
                page: pageItem.querySelector('.js-page-link').getAttribute('data-page'),
                label: pageItem.querySelector('.js-page-link').innerHTML.trim()
            });
        },

        updatePaginator: function(response) {
            var parser = new DOMParser(),
                paginationDom;

            this.pageList = [];
            this.hasPagination = response.data.pages > 1;
            paginationDom = parser.parseFromString(response.data.html_pager, 'text/html');
            paginationDom.querySelectorAll('.js-page-item').forEach(this.addDomPage);
        },

        initPaginator: function() {
            if (window.location.hash !== '') {
                this.onHashChange();
            }
        },

    }
};
